import React from "react";

const VIEWBOX_HEIGHT = 90;

const GLYPHS = {
  A: { p: ["M 8,74 L 30,16 L 52,74", "M 17,50 L 43,50"], w: 62 },
  B: {
    p: [
      "M 14,16 L 14,74",
      "M 14,16 C 44,16 46,22 46,35 C 46,46 44,46 14,46",
      "M 14,46 C 46,46 48,54 48,64 C 48,74 44,74 14,74"
    ],
    w: 62
  },
  C: { p: ["M 56,26 C 44,8 8,10 8,45 C 8,68 22,78 56,72"], w: 66 },
  D: { p: ["M 14,16 L 14,74", "M 14,16 C 56,16 58,26 58,45 C 58,64 56,74 14,74"], w: 72 },
  E: { p: ["M 14,16 L 14,74", "M 14,16 L 54,16", "M 14,45 L 48,45", "M 14,74 L 54,74"], w: 66 },
  F: { p: ["M 14,16 L 14,74", "M 14,16 L 54,16", "M 14,45 L 48,45"], w: 62 },
  G: { p: ["M 56,26 C 44,8 8,10 8,45 C 8,68 22,78 54,78 C 62,78 62,68 62,60 L 62,52 L 42,52"], w: 74 },
  H: { p: ["M 14,16 L 14,74", "M 52,16 L 52,74", "M 14,45 L 52,45"], w: 68 },
  I: { p: ["M 10,16 L 42,16", "M 26,16 L 26,74", "M 10,74 L 42,74"], w: 54 },
  J: { p: ["M 38,16 L 38,62 C 38,80 10,84 8,68"], w: 52 },
  K: { p: ["M 14,16 L 14,74", "M 52,16 L 14,48", "M 24,42 L 54,74"], w: 68 },
  L: { p: ["M 14,16 L 14,74 L 54,74"], w: 68 },
  M: { p: ["M 8,74 L 8,16 L 32,52 L 56,16 L 56,74"], w: 66 },
  N: { p: ["M 10,74 L 10,16 L 52,74 L 52,16"], w: 64 },
  O: { p: ["M 32,16 C 8,16 6,74 32,74 C 58,74 60,16 32,16"], w: 70 },
  P: { p: ["M 14,16 L 14,74", "M 14,16 C 50,16 52,24 52,38 C 52,52 50,54 14,54"], w: 64 },
  Q: { p: ["M 32,16 C 8,16 6,74 32,74 C 58,74 60,16 32,16", "M 44,62 L 62,80"], w: 72 },
  R: { p: ["M 14,16 L 14,74", "M 14,16 C 50,16 52,24 52,38 C 52,52 48,54 14,54", "M 28,52 L 56,74"], w: 68 },
  S: { p: ["M 56,26 C 44,8 8,12 10,32 C 12,48 56,50 58,66 C 60,80 24,84 8,70"], w: 68 },
  T: { p: ["M 6,16 L 56,16", "M 31,16 L 31,74"], w: 64 },
  U: { p: ["M 12,16 L 12,58 C 12,80 54,80 54,58 L 54,16"], w: 68 },
  V: { p: ["M 8,16 L 32,74 L 56,16"], w: 66 },
  W: { p: ["M 6,16 L 20,74 L 34,42 L 48,74 L 62,16"], w: 70 },
  X: { p: ["M 8,16 L 56,74", "M 56,16 L 8,74"], w: 66 },
  Y: { p: ["M 8,16 L 32,50 L 56,16", "M 32,50 L 32,74"], w: 66 },
  Z: { p: ["M 8,16 L 56,16 L 8,74 L 56,74"], w: 66 },
  a: { p: ["M 50,46 C 30,34 8,40 8,58 C 8,76 28,82 50,74 L 50,46 L 52,74"], w: 62 },
  b: { p: ["M 12,16 L 12,74", "M 12,60 C 12,40 52,40 52,62 C 52,80 30,84 12,74"], w: 64 },
  c: { p: ["M 54,52 C 42,34 8,40 8,60 C 8,80 30,86 54,78"], w: 64 },
  d: { p: ["M 52,16 L 52,74", "M 52,60 C 52,40 10,40 10,62 C 10,80 30,84 52,74"], w: 64 },
  e: { p: ["M 8,60 L 52,60 C 52,44 30,34 10,46 C 2,60 12,82 44,82"], w: 62 },
  f: { p: ["M 44,24 C 38,8 16,10 16,26 L 16,74", "M 6,48 L 40,48"], w: 54 },
  g: { p: ["M 50,46 C 32,34 8,40 8,60 C 8,78 28,82 50,74 L 50,46", "M 50,72 L 50,88 C 50,100 22,104 8,90"], w: 62 },
  h: { p: ["M 10,16 L 10,74", "M 10,54 C 12,36 36,32 48,46 L 48,74"], w: 60 },
  i: { p: ["M 18,46 L 18,74", "M 17,32 C 17,28 22,28 22,32 C 22,36 17,36 17,32"], w: 38 },
  j: { p: ["M 22,46 L 22,74 C 22,88 6,92 4,80", "M 21,32 C 21,28 26,28 26,32 C 26,36 21,36 21,32"], w: 40 },
  k: { p: ["M 10,16 L 10,74", "M 48,46 L 14,60", "M 22,54 L 50,74"], w: 62 },
  l: { p: ["M 16,16 L 16,74"], w: 36 },
  m: { p: ["M 6,46 L 6,74", "M 6,56 C 8,40 24,36 32,48 L 32,74", "M 32,56 C 34,40 50,36 58,48 L 58,74"], w: 68 },
  n: { p: ["M 8,46 L 8,74", "M 8,56 C 10,38 32,34 44,48 L 44,74"], w: 56 },
  o: { p: ["M 28,46 C 8,46 6,74 28,74 C 50,74 52,46 28,46"], w: 62 },
  p: { p: ["M 10,46 L 10,90", "M 10,62 C 10,42 52,42 52,64 C 52,82 28,86 10,76"], w: 62 },
  q: { p: ["M 52,46 L 52,90", "M 52,62 C 52,42 10,42 10,64 C 10,82 30,86 52,76"], w: 64 },
  r: { p: ["M 8,46 L 8,74", "M 8,60 C 14,40 34,36 50,48"], w: 58 },
  s: { p: ["M 50,52 C 40,36 8,40 8,56 C 8,70 50,68 52,80 C 54,90 24,92 8,80"], w: 62 },
  t: { p: ["M 28,18 L 28,74", "M 10,48 L 46,48"], w: 56 },
  u: { p: ["M 8,46 L 8,62 C 8,80 52,80 52,62 L 54,74 L 52,46"], w: 64 },
  v: { p: ["M 6,46 L 30,74 L 54,46"], w: 62 },
  w: { p: ["M 4,46 L 16,74 L 28,54 L 40,74 L 52,46"], w: 58 },
  x: { p: ["M 8,46 L 52,74", "M 52,46 L 8,74"], w: 62 },
  y: { p: ["M 8,46 L 30,74", "M 52,46 L 14,90"], w: 62 },
  z: { p: ["M 8,46 L 52,46 L 8,74 L 52,74"], w: 62 },
  "0": { p: ["M 30,16 C 8,16 6,74 30,74 C 54,74 54,16 30,16"], w: 62 },
  "1": { p: ["M 10,30 L 26,16 L 26,74"], w: 44 },
  "2": { p: ["M 8,28 C 10,10 56,10 56,32 C 56,52 8,58 6,74 L 56,74"], w: 66 },
  "3": { p: ["M 8,22 C 20,8 56,10 54,32 C 52,44 26,44 26,44", "M 28,44 C 48,44 58,54 56,68 C 54,80 22,82 8,70"], w: 66 },
  "4": { p: ["M 46,74 L 46,16 L 6,56 L 60,56"], w: 68 },
  "5": { p: ["M 54,16 L 8,16 L 6,44 C 26,32 58,40 56,62 C 54,76 24,82 6,70"], w: 64 },
  "6": { p: ["M 46,20 C 34,4 6,14 6,46 C 6,70 20,80 40,78 C 58,76 60,62 44,54 C 28,46 6,54 8,66"], w: 66 },
  "7": { p: ["M 6,16 L 58,16 L 22,74"], w: 66 },
  "8": { p: ["M 30,16 C 10,16 10,46 30,46 C 50,46 50,74 30,74 C 10,74 10,46 30,46"], w: 64 },
  "9": { p: ["M 54,44 C 54,14 8,12 8,44 C 8,64 24,74 46,68 C 60,62 58,40 54,66 C 50,82 24,86 8,74"], w: 66 },
  " ": { p: [], w: 28 },
  ".": { p: ["M 18,68 C 18,64 23,64 23,68 C 23,72 18,72 18,68"], w: 36 },
  ",": { p: ["M 20,68 C 20,64 24,64 24,68 C 24,75 18,82 14,86"], w: 34 },
  "!": { p: ["M 24,16 L 22,54", "M 21,65 C 21,61 26,61 26,65 C 26,69 21,69 21,65"], w: 44 },
  "?": { p: ["M 8,28 C 10,10 52,10 52,30 C 52,50 28,52 28,60", "M 27,68 C 27,64 32,64 32,68 C 32,72 27,72 27,68"], w: 60 },
  "-": { p: ["M 8,45 L 52,45"], w: 62 },
  "&": { p: ["M 50,74 C 34,66 6,56 8,38 C 10,24 28,22 38,36 C 50,52 16,66 6,76 L 58,76", "M 44,52 L 58,36"], w: 72 },
  "'": { p: ["M 18,18 C 18,14 22,14 22,18 C 22,25 18,31 15,35"], w: 26 },
  ":": { p: ["M 20,34 C 20,30 25,30 25,34 C 25,38 20,38 20,34", "M 20,66 C 20,62 25,62 25,66 C 25,70 20,70 20,66"], w: 34 }
};

const SUPPORTED_GLYPHS = new Set(Object.keys(GLYPHS));

const VARIANTS = {
  hero: { scale: 0.26, strokeWidth: 12 },
  section: { scale: 0.2, strokeWidth: 11 },
  card: { scale: 0.16, strokeWidth: 10 },
  small: { scale: 0.135, strokeWidth: 9 }
};

export function supportsWonderGlyphText(text) {
  if (typeof text !== "string" || !text.trim()) {
    return false;
  }

  return Array.from(text).every((character) => SUPPORTED_GLYPHS.has(character));
}

function Glyph({ character, scale, strokeWidth }) {
  const glyph = GLYPHS[character] || GLYPHS[" "];

  return (
    <svg
      viewBox={`0 0 ${glyph.w} ${VIEWBOX_HEIGHT}`}
      width={glyph.w * scale}
      height={VIEWBOX_HEIGHT * scale}
      className="wonderGlyphText__glyph"
      aria-hidden="true"
      focusable="false"
    >
      {(glyph.p || []).map((path, index) => (
        <path
          key={`${character}-${index}`}
          d={path}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      ))}
    </svg>
  );
}

export default function WonderGlyphText({
  text,
  as: Tag = "span",
  variant = "section",
  className = "",
  style,
  title
}) {
  if (typeof text !== "string" || !text.trim()) {
    return null;
  }

  if (!supportsWonderGlyphText(text)) {
    return (
      <Tag className={className} style={style} title={title}>
        {text}
      </Tag>
    );
  }

  const glyphStyle = VARIANTS[variant] || VARIANTS.section;

  return (
    <Tag
      className={`wonderGlyphText ${className}`.trim()}
      style={style}
      aria-label={text}
      title={title || text}
    >
      <span className="wonderGlyphText__srOnly">{text}</span>
      <span className="wonderGlyphText__line" aria-hidden="true">
        {Array.from(text).map((character, index) => (
          <Glyph
            key={`${character}-${index}`}
            character={character}
            scale={glyphStyle.scale}
            strokeWidth={glyphStyle.strokeWidth}
          />
        ))}
      </span>
    </Tag>
  );
}
